import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      stroke: "currentColor",
      "stroke-linejoin": "round",
      "stroke-width": "1.75",
      d: "M12 20.3s5.25-4.25 5.25-9.4a5.25 5.25 0 1 0-10.5 0c0 5.15 5.25 9.4 5.25 9.4Z"
    }, null, -1),
    _createElementVNode("circle", {
      cx: "12",
      cy: "10.7",
      r: "1.85",
      stroke: "currentColor",
      "stroke-width": "1.75"
    }, null, -1),
    _createElementVNode("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-width": "1.6",
      d: "M4.7 15.9h1.85m10.9-9.35h1.85"
    }, null, -1)
  ]))]))
}
export default { render: render }